// Minimal "return here after sign-in" plumbing for the checkout gate. When the
// auth guard bounces a signed-out visitor from a gated route (e.g. /checkout),
// it stashes the intended path; the sign-in flow (magic-link verify / OAuth
// return) consumes it and navigates there instead of home. Stored in
// localStorage — not a URL ?next= — so it survives the magic-link email
// round-trip, which can open a fresh tab. Only internal ("/…") paths are kept.
const KEY = 'asmaluz.returnTo';

export function setReturnTo(path: string): void {
  try {
    if (path && path.startsWith('/')) localStorage.setItem(KEY, path);
  } catch {
    // storage unavailable — returnTo just won't persist
  }
}

// takeReturnTo returns the stashed path (once) and clears it, or null.
export function takeReturnTo(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v) localStorage.removeItem(KEY);
    return v && v.startsWith('/') ? v : null;
  } catch {
    return null;
  }
}
